import { useMemo } from "react";

import { InputGroup, Label } from "../Form";
import useBulkPaste from "./useBulkPaste";
import {
  ModalButtonContainer,
  ModalHeader,
  ModalColumn,
  ModalText,
  ModalTextarea,
} from "./styles";
import Button from "core/components/Button";

const BulkPasteEditor = () => {
  const { draftValues, setDraftValues, label, hideModal, saveEditor } =
    useBulkPaste();

  const isSaveEditorDisabled = useMemo(
    () => draftValues?.trim().length === 0,
    [draftValues]
  );

  return (
    <ModalColumn>
      <ModalHeader>Add {label}</ModalHeader>

      <ModalText>
        Copy and paste your {label} below with one per line.
      </ModalText>

      <InputGroup>
        <Label>{label}</Label>

        <ModalTextarea
          value={draftValues}
          placeholder={`Copy and paste your ${label}`}
          onChange={(event) => setDraftValues(event.target.value)}
          data-test="modal-textarea"
        />
      </InputGroup>

      <ModalButtonContainer>
        <Button
          variant="outlined"
          onClick={hideModal}
          data-test="modal-cancel-button"
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          onClick={saveEditor}
          disabled={isSaveEditorDisabled}
          data-test="modal-submit-button"
        >
          Add {label}
        </Button>
      </ModalButtonContainer>
    </ModalColumn>
  );
};

export default BulkPasteEditor;
